import React, { useState } from 'react';
import { QuickFilterButton, Button, Link } from '@hpi-sox/hpstellar-core';
import { ChevronUp } from '@hpi-sox/hpstellar-icons';

import withPageComponents from '../../page/components/with-page-components';

import './filter-bar.less';

const getRows = (pills, width, collapse, rows = 2) => {
    if (collapse) {
        return pills;
    }

    let span = 0;
    let items = [];
    let row = 1;

    const breakpoint = width >= 1024;

    const offset = breakpoint ? 270 : 32;
    const pillWidth = 42;
    const letterWidth = 8;

    for (let i = 0; i < pills.length; i++) {
        const item = pills[i];
        span += pillWidth;
        span += item.displayName.length * letterWidth;

        if (span < Math.min(rows * (1920 - offset), rows * (width - offset)) && row <= rows) {
            items.push(item);
        } else if (row <= rows) {
            row++;
            span = pillWidth + item.displayName.length * letterWidth;
        }
    }

    const more = pills.length - items.length;
    if (more > 0) {
        items.pop();
        items.push({ displayName: `+ ${more + 1}`, key: 'more', urlValue: 'more' });
    }

    return items;
};

function FilterBar({ filterClear, onSelectFacet, filters, width, isMobile }) {
    const [collapse, setCollapse] = useState(false);

    return (
        <div className="filterBar">
            <div className="filterBar-clear">{filterClear}</div>
            <div className="filterBar-filters">
                <div className="filterBar-filters-content">
                    {getRows(filters, width, collapse, isMobile ? 1 : 2).map(f => {
                        if (f.key === 'more') {
                            return (
                                <Link
                                    key="more"
                                    className="filter-button-more"
                                    variation="inText"
                                    onClick={() => setCollapse(true)}
                                >
                                    {f.displayName}
                                </Link>
                            );
                        }

                        return (
                            <QuickFilterButton
                                key={`filter-${f.urlValue}`}
                                className="filter-button"
                                onClick={onSelectFacet(f.key, f.urlValue)}
                                isActive
                            >
                                {f.displayName}
                            </QuickFilterButton>
                        );
                    })}
                </div>
                <div className="filterBar-filters-collapse">
                    {collapse && (
                        <Button
                            variation="tertiary"
                            isFixed
                            color="dark"
                            starIcon={<ChevronUp size="s" />}
                            endIcon={<ChevronUp size="s" />}
                            onClick={() => setCollapse(false)}
                        >
                            COLLAPSE
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default withPageComponents(FilterBar, {
    device: true,
});
